export class LogMapsGoogleDto {

    public screen: string;
    public service: string;
    public jsonParams: string;

    public static build(screen: string, service: string, jsonParams: string): LogMapsGoogleDto{
        let dto = new LogMapsGoogleDto();
        dto.screen = screen;
        dto.service = service;
        dto.jsonParams = jsonParams;
        return dto;
    }
}